import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'
import {i18n} from '@toolify/client/src/setup/i18n'

export class WorkspaceAppAccessRequestPendingNotificationStrategy extends DefaultNotificationStrategy<NotificationType.WorkspaceAppAccessRequestPending> implements INotificationTypeStrategy {
  getBrowserNotification(
    notification: INotificationResponseInstance<NotificationType.WorkspaceAppAccessRequestPending>,
    authorNick: string,
  ): IBrowserNotification {
    const p = notification.payload
    return {
      sound: getNotificationSoundUrl('new-notification.wav'),
      title: ENV.AppBrandingName,
      body: i18n.global.t('notifications.browser.workspaceAppAccessRequestPendingBody', {
        authorNick,
        appName: p.appName,
        workspaceName: p.workspaceName,
      }).toString(),
    }
  }
}
